export const SELECTIONS = {
  OPT_IN: 'opt_in',
  OPT_OUT: 'opt_out',
};

export const TYPE = {
  SIMPLE: 'simple',
  COMPLETE: 'complete',
};
